<form novalidate>
    <div class="modal-header justify-content-center">
        <h4 class="modal-title">{{appointment.taskAlias}} ({{appointment.taskCount}})</h4>
    </div>

    <div class="modal-body">
        <schedule-detail #scheduleDetail
                         *ngIf="appointment.taskInstances[0]"
                         [task]="appointment.taskInstances[0]"
                         [appointment]="appointment"
                         [taskType]="appointment.taskType"
                         [facet]="facet"
        ></schedule-detail>

    </div>

    <div class="modal-footer">
        <button type="button"
                *ngIf="!(appointment.isLocked || appointment.isGroup)"
                class="btn btn-fw btn-lg btn-primary"
                [disabled]="saving"
                (click)="onSubmit()">
            Save
            <span *ngIf="saving">
                <i class="fa fa-spinner fa-spin" title="Saving&hellip;"></i>
            </span>
        </button>
        <button type="button"
                class="btn btn-fw btn-lg btn-secondary"
                [disabled]="saving"
                (click)="onCancel()">
            Cancel
        </button>
    </div>
</form>
